import { Pipe, PipeTransform } from '@angular/core';
import { orderBy } from 'lodash';

@Pipe({
  name: 'sortByOrder'
})
export class SortByOrderPipe implements PipeTransform {

  transform(value: any[], order: string = '', column: string = ''): any[] {
    if (!value || order === '' || !order) {
      return value;
    } // no array
    if (!column || column !== '') {
      if (order === 'asc') {
        return value.sort();
      } else {
        // const bb = value.sort((a, b) => (a.version > b.version) ? -1 : 1);
        return value.sort((a, b) => (a.version > b.version) ? -1 : 1);
      }
    } // sort 1d array
    if (value.length <= 1) {
      return value;
    } // array with only one item
    return orderBy(value, [column]);
  }

}
